import Vue from 'vue';
import { logout } from '@/common/preload/auth';
import i18n from '@/plugins/i18n';
import { Sockets } from './modules/Sockets';
import { Socket } from './modules/MediaSoup/Socket';

export const sockets = new Sockets();
Vue.prototype.$sockets = sockets.collection;
export const mediasoupSockets = new Socket();
Vue.prototype.$mediasoupSockets = mediasoupSockets;

export function openSockets() {
  sockets.open('webRTC', '');
  sockets.open('chat', '/chat');
  sockets.open('drawer', '/drawer');
  sockets.open('appointment', '/appointments');
  sockets.open('account', '/account');
  // add-google-cloud-storage-bucket
  // Delete this line after testing
  // sockets.open('csv', '/csv');
  // sockets.open('file834', '/file834');
  sockets.open('files', '/files');
  mediasoupSockets.open();

  // appointment sockets
  // sockets.collection.appointment.on('appointment_waiting_for_room', msg => {
  //   console.log('Root socket event [appointment.appointment_waiting_for_room]', msg);
  //   Vue.prototype.$notifyInfo('You have a patient in the waiting room more than 1 minute', i18n.t('snotify.infoTitle'));
  // });

  // account sockets
  sockets.collection.account.on('auth_logged_in_from_another_device', () => {
    Vue.prototype.$clearTabSession();
    Vue.prototype.$notifyError(i18n.t('notifications.loggedOnAnotherDevice'), i18n.t('snotify.errorTitle'), { timeout: 5000 });
    logout();
  });
}

export default sockets;
